import styled from 'styled-components/macro';
import { colourNeutral09 } from '../styling/colours';
import { spacing01, spacing02, spacing08, spacing09, spacing11 } from '../styling/spacing';
import { Table, Td, Th } from './Table';

// Because the left and right table are split, we have to manually set these heights so
// the headers line up
// On the left: 88px + (2 * 8px padding) = 104px
// On the right: 17px + 1px border + (2 * 8px padding) + 54px + (2 * 8px padding) = 104px
const TableHeaderFullHeight = '88px';
const GroupingTableHeaderHeight = '17px';
const GroupedTableHeaderHeight = '54px';

export const Container = styled.div`
  display: flex;
`;

export const LeftTableContainer = styled.div`
  overflow-x: visible;
  margin-right: -2px;
`;

export const FullHeightTh = styled(Th)`
  height: ${TableHeaderFullHeight};
`;

export const NarrowTh = styled(FullHeightTh)`
  min-width: ${spacing08};
`;

export const WideTh = styled(FullHeightTh)`
  min-width: ${spacing09};
`;

export const ExtraWideTh = styled(FullHeightTh)`
  min-width: ${spacing11};
`;

export const TightTable = styled(Table)`
  ${Th} {
    padding: ${spacing02} ${spacing01};
  }

  ${Td} {
    padding: ${spacing01};
  }
`;

export const LeftTable = styled(TightTable)`
  ${Td} {
    height: 40px;
  }
`;

export const RightTableContainer = styled.div`
  display: inline-block;
  overflow-x: auto;
  width: 100%;
`;

export const RightTable = styled(TightTable)`
  table-layout: auto;
  width: 100%;

  ${Th}, ${Td} {
    min-width: 80px;
  }
  select {
    min-width: 130px;
  }
`;

export const TdBorderLeft = styled(Td)`
  border-left: solid 2px ${colourNeutral09};
`;

export const TdBorderRight = styled(Td)`
  border-right: solid 2px ${colourNeutral09};
`;

export const NoWrapTd = styled(Td)`
  white-space: nowrap;
`;

export const GroupingTh = styled(Th)`
  border-left: solid 2px ${colourNeutral09};
  border-right: solid 2px ${colourNeutral09};
  text-align: center;
  border-bottom: dashed 1px ${colourNeutral09};
  height: ${GroupingTableHeaderHeight};
`;

export const GroupedTh = styled(Th)`
  height: ${GroupedTableHeaderHeight};
`;

const ThBorderLeft = styled(Th)`
  border-left: solid 2px ${colourNeutral09};
`;

export const GroupedThBorderLeft = styled(ThBorderLeft)`
  height: ${GroupedTableHeaderHeight};
`;

export const FullHeightThBorderLeft = styled(ThBorderLeft)`
  height: ${TableHeaderFullHeight};
`;

const ThBorderRight = styled(Th)`
  border-right: solid 2px ${colourNeutral09};
`;

export const GroupedThBorderRight = styled(ThBorderRight)`
  height: ${GroupedTableHeaderHeight};
`;

export const FullHeightThBorderRight = styled(ThBorderRight)`
  height: ${TableHeaderFullHeight};
`;
